import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import {Dispatch} from '@reduxjs/toolkit'
import {trackTimingEvent} from 'middleware/analytics'
import {once} from 'ramda'

import {logTimeStart} from '@vio/core/src/_web/utils/logging/performanceTimer'
import {Entity} from '@vio/core/src/analytics/types/Events'
import {debounce} from '@vio/core/src/utils/debounce'

const trackDatePickerReady = debounce((dispatch: Dispatch) => {
  trackTimingEvent(
    dispatch,
    'DatePickerReady',
    'DatePickerReady-start',
    Entity.DatePicker
  )
})

const trackDatePickerLoaded = once((dispatch: Dispatch) => {
  trackTimingEvent(
    dispatch,
    'DatePickerLoaded',
    'DatePickerLoaded-start',
    Entity.DatePicker
  )
})

export const useDatePickerTiming = () => {
  const dispatch = useDispatch()

  const datePickerReadyTimerStart = () => {
    logTimeStart('DatePickerReady')
  }

  const datePickerLoadedTimerStart = () => {
    logTimeStart('DatePickerLoaded')
  }

  const datePickerReadyTimerEnd = useCallback(
    () => trackDatePickerReady(dispatch),
    [dispatch]
  )

  const datePickerLoadedTimerEnd = useCallback(
    () => trackDatePickerLoaded(dispatch),
    [dispatch]
  )

  return {
    datePickerReadyTimerStart,
    datePickerReadyTimerEnd,
    datePickerLoadedTimerStart,
    datePickerLoadedTimerEnd
  }
}
